import React from 'react'
import TextTruncated from '../TextTruncated/TextTruncated'
import {
  getDetailPoster,
  generateGenres,
  generateCasts,
  formatDuration
} from '../../utils'
import styles from './MediaInfo.module.css'

const MediaInfo = ({ detail, access, onWatchClicked }) => {
  const poster = getDetailPoster(detail)
  const duration = detail.duration && formatDuration(detail.duration)
  const tags = detail.tags
  const genres = generateGenres(tags)
  const casts = generateCasts(tags)
  const subscribed = (!access || access.error) ? styles['not-subscribed-button'] : ''

  return (
    <div className={styles['media-info-wrapper']}>
      <div className={styles['general-info-wrapper']}>
        <div className={styles['gradient-top']} />
        <img src={poster} alt='detail poster' className={styles['thumbnail']} />
        <div className={styles['media-metadata-wrapper']}>
          <div className={styles['media-title']}>{detail.titleLocalized}</div>
          <div className={styles['media-metadata']}>
            <p className={styles['year']}>{detail.year}</p>
            <p className={styles['genre']}>{genres}</p>
            <p className={styles['duration']}>{duration}</p>
            <p className={styles['rating']}>{detail.rating}</p>
          </div>
          <button className={subscribed} onClick={onWatchClicked}>Watch Now</button>
        </div>
        <div className={styles['gradient-bottom']} />
      </div>
      <div className={styles['description']}>
        <TextTruncated
          content={detail.descriptionLongLocalized || ''}
          maxLength={250}
        />
      </div>
      {casts && (
        <div className={styles['casting']}>
          <h3>CAST</h3>
          <span>{casts}</span>
        </div>
      )}
    </div>
  )
}

export default MediaInfo
